import React, { useState } from 'react';
import * as cn from 'classnames';
import PropTypes from 'prop-types';

import './Container.scss';

const Header = ({ className, children }) => (
  <div className={cn('header', { [className]: !!className })}>{children}</div>
);

const Title = ({ id, className, text }) => (
  <h1 id={id} className={cn('display-6 title', { [className]: !!className })}>
    {text}
  </h1>
);

const Description = ({ text }) =>
  typeof text === 'string' ? <p className="description">{text}</p> : text;

const Lead = ({ text }) =>
  typeof text === 'string' ? <p className="lead">{text}</p> : text;

const ShowMore = ({ onClick }) => (
  <div className="footer">
    <div className="text-center">
      <span className="btn-show small text-gray" onClick={onClick}>
        Show More
      </span>
    </div>
  </div>
);

function Container({
  id,
  title,
  description,
  lead,
  className,
  headerClassName,
  titleClassName,
  moreAction,
  nthChildShow,
  children,
  ...props
}) {
  const [isShowMore, setShowMore] = useState(false);

  const filtered = (elem) => {
    let NewElem = <elem.type {...elem.props}>{elem.props.children}</elem.type>;

    if (moreAction && !isShowMore) {
      let child = [];

      for (let i = 0; i < nthChildShow; i++) {
        child.push(elem.props.children[i]);
      }

      NewElem = <elem.type>{child}</elem.type>;
    }

    return NewElem;
  };

  return (
    <div
      id={id}
      className={cn('container-lg', {
        [className]: !!className,
        'show-less': !!moreAction && !isShowMore,
      })}
      {...props}
    >
      {(!!title || !!description || lead) && (
        <Header className={headerClassName}>
          {!!title && <Title className={titleClassName} text={title} />}
          {!!description && <Description text={description} />}
          {!!lead && <Lead text={lead} />}
        </Header>
      )}
      <div className="body">
        {typeof children === 'string'
          ? filtered(<div>{children}</div>)
          : filtered(children)}
      </div>
      {moreAction && !isShowMore && (
        <ShowMore onClick={() => setShowMore(true)} />
      )}
    </div>
  );
}

Container.defaultProps = {
  className: '',
  headerClassName: '',
  titleClassName: '',
  id: '',
  title: '',
  description: '',
  lead: '',
  moreAction: false,
  nthChildShow: 4,
};

Container.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.any,
  description: PropTypes.any,
  lead: PropTypes.any,
  moreAction: PropTypes.bool,
  nthChildShow: PropTypes.number,
};

export default React.memo(Container);
